// Translations are split into per-language JSON files for easier maintenance.
// To edit copy: open /app/frontend/src/locales/{en,da,pt}.json
// Each file contains only that language's text — a typo in one language won't break the others.
import en from './locales/en.json';
import da from './locales/da.json';
import pt from './locales/pt.json';

export const translations = { en, da, pt };
